<modal id="take-test">
	<div class="modal">
		<div class="modal__container">
			<div class="modal__block-icon">
				<img class="modal__cross" (click)="closeModal('take-test');" src="assets/images/education/icons/icon__cross--white.svg" alt="">
			</div>
			<div class="modal__inner">
				<h2 class="modal__text">Мы видим, ты интересуешься разными направлениями стажировок</h2>
				<h2 class="modal__text modal__text--bold">Не знаешь с чего начать? Пройди тест и узнай свою суперсилу!</h2>

				<button class="modal__button" (click)="openTest()">Пройти</button>
			</div>
		</div>
	</div>
	<div class="modal__background" (click)="closeModal('take-test');"></div>
</modal>

<app-career-test></app-career-test>
